import React from 'react';
import { IBaseAction } from '@models/actions/IBaseAction';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import { ModalSize } from '@/types/ModalSize';
import { IBatchActivitiesCompleteExecutorProps } from './IBatchActivitiesCompleteExecutorProps';
import { BatchActivitiesCompleteExecutorModal } from './BatchActivitiesCompleteExecutorModal';

export class BatchActivitiesCompleteExecutor extends DocBaseActionExecutor {
    private _modalProps?: IBatchActivitiesCompleteExecutorProps;

    runInternal = (
        objId: string,
        parentId: string | undefined,
        action: IBaseAction,
        rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
        modalSize?: ModalSize | null,
    ) => {
        this._modalProps = {
            docId: objId ?? '',
            actionKey: action.key ?? '',
            title: action.options?.title ?? '',
            okButtonText: action.options?.okButtonText ?? 'ОК',
            cancelButtonText: action.options?.cancelButtonText ?? 'Отмена',
            modalSize: modalSize ?? action.options?.modalSize ?? 'm',
            completeHandler: completeHandler,
        };
    };

    visualElementInner = () => {
        return this._modalProps ? <BatchActivitiesCompleteExecutorModal {...this._modalProps} /> : <div />;
    };
}
